export const CIRCLE_RADIUS = 9;
export const CIRCLE_STROKE_WIDTH = 2;

export const SMALL_CIRCLE_RADIUS = 6;
export const SMALL_CIRCLE_STROKE_WIDTH = 2;

export const TINY_CIRCLE_RADIUS = 4;
export const TINY_CIRCLE_STROKE_WIDTH = 2;
